import { useState } from 'react';
import { Alert, Button } from '@mui/material';
import { useExportUsersCsv } from 'src/api/contests/exportCsv';
import Iconify from 'src/components/iconify';
import { useAppSearchParams } from 'src/hooks/useAppSearchParams';

const downloadFile = (data: any, contestId: number) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  const now = new Date();
  const dateTime = now.toISOString().slice(0, 16).replace('T', ' ');
  link.setAttribute('download', `contest-${contestId} ${dateTime}.csv`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

export const ExportUsersCsvButton = () => {
  const { contestId } = useAppSearchParams();

  const [showError, setShowError] = useState(false);
  const { mutateAsync, isPending, error } = useExportUsersCsv(contestId);

  const handleDownloadCsv = async () => {
    try {
      const data = await mutateAsync();

      if (!data) return setShowError(true);

      downloadFile(data, contestId);
    } catch (error) {
      console.error('Error during CSV download:', error);
      setShowError(true);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <Button
        variant='contained'
        startIcon={<Iconify icon='eva:download-outline' />}
        onClick={() => handleDownloadCsv()}
        disabled={isPending}
      >
        Export Users Csv
      </Button>
      {showError && (
        <Alert
          severity='error'
          sx={{ position: 'absolute', top: 50, left: `-50%`, width: 500 }}
          onClose={() => setShowError(false)}
        >
          Error during CSV download: {error?.message}
        </Alert>
      )}
    </div>
  );
};
